module.exports = __webpack_public_path__ + "img/image-remote.6e8c7ad5.png";